import React from 'react';
import './styles.scss';

function resolveColor(contrast: any) {
    const normalized = Math.min(Math.max(Number(contrast || 10), 1), 10);
    return `var(--surface-${11 - normalized})`;
}

function createTextVariant(tag: any, className: string, defaults: any = {}) {
    return React.forwardRef<any, any>(({
        contrast = defaults.contrast ?? 10,
        weight = defaults.weight ?? null,
        uppercase = defaults.uppercase ?? false,
        grow = false,
        className: userClassName = '',
        style,
        children,
        value,
        ...props
    }, ref) => {
        const Component = tag as any;
        const combinedClassName = [
            'text-component',
            className,
            grow ? 'text-grow' : '',
            uppercase ? 'text-uppercase' : '',
            userClassName,
        ].filter(Boolean).join(' ');
        const resolvedStyle = {
            color: resolveColor(contrast),
            ...(weight ? { fontWeight: weight } : {}),
            ...(style || {}),
        };

        return (
            <Component
                ref={ref}
                className={combinedClassName}
                style={resolvedStyle}
                {...props}
            >
                {children ?? value}
            </Component>
        );
    });
}

const Text = {
    h1: createTextVariant('h1', 'text-h1'),
    h2: createTextVariant('h2', 'text-h2'),
    h3: createTextVariant('h3', 'text-h3'),
    h4: createTextVariant('h4', 'text-h4'),
    h5: createTextVariant('h5', 'text-h5'),
    h6: createTextVariant('h6', 'text-h6'),
    p: createTextVariant('p', 'text-p'),
    span: createTextVariant('span', 'text-span'),
    small: createTextVariant('small', 'text-small'),
    subheading: createTextVariant('span', 'text-subheading', { contrast: 6, weight: 600, uppercase: true }),
    label: createTextVariant('span', 'text-label', { contrast: 9, weight: 500 }),
    caption: createTextVariant('span', 'text-caption', { contrast: 6 }),
};

export default Text;
